import { PutTripDestinationsType } from '@orbit/api-types'
import { usePut } from '@hooks/useApi'
import { queryKeys } from '@lib/queryKeys'
import { useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

/**
 * `PUT /trips/:id/destinations` (ADR 0007): the full ordered destination list,
 * plus the start date when it moved. Days move with their destinations —
 * events, day info and travel segments included — so the itinerary content
 * keys refetch along with the trip.
 */
export const useUpdateTripDestinations = (tripId: string) => {
	const queryClient = useQueryClient()

	return usePut<PutTripDestinationsType, Trip>(`/trips/${tripId}/destinations`, {
		onSuccess: updatedTrip => {
			queryClient.invalidateQueries({ queryKey: queryKeys.trip(tripId) })
			queryClient.invalidateQueries({ queryKey: queryKeys.trips() })
			for (const queryKey of queryKeys.itineraryContentKeys(tripId)) {
				queryClient.invalidateQueries({ queryKey })
			}
			queryClient.setQueryData(queryKeys.trip(tripId), updatedTrip)
		},
	})
}
